import { useEffect, useMemo }   from 'react';
import { store }                from 'index';
import { SET_MANUAL_NAV_STATE } from 'actions/manualNavigationActions';
import { manualNavStateType }   from 'reducer/types';
import { pagesWithGrid }        from 'utils/constants';
import { appTopicsArrType }     from 'types';

  
const useManualNavigation = (
  contentTopics:       string[],
  appTopicsArr:        appTopicsArrType[],
  setChangeContent:    (variant: boolean) => void,
  showTeacherUrlModal: () => void,
) => {

    const state             = store.getState();
    const sizeState         = state.size;
    const page              = state.page.page;
    const manualNavState    = state.manualNav;

    const showGrid = useMemo(() => {
      return pagesWithGrid.includes(page)
    },[page])


    useEffect(() => {

      const setManualNavState = (val: manualNavStateType) => store.dispatch(SET_MANUAL_NAV_STATE(val));
  
      const keyPressHandler = (e: any) => {
  
        if ( !sizeState.wideScreen ) {
            if ( manualNavState.manualOn ) {
              setManualNavState({
                ...manualNavState,
                manualOn: false
              })
            }
          return;
        }
  
        if ( e.key !== 'Tab'  && !manualNavState.manualOn  ) {
          return;
        }
  
        if ( e.key === 'Tab' || e.key === 'Enter' || e.key === 'Escape' ) {
           e.preventDefault();
           import("functions/handle_key_press").then(func => {
            func.handleKeyPress(
              e.key,
              showGrid,
              contentTopics,
              appTopicsArr,
              showTeacherUrlModal,
              setChangeContent
            );
          });
           
        }
      };
  
      document.addEventListener('keydown', keyPressHandler);
      return () => {
        document.removeEventListener('keydown', keyPressHandler);
      };
    }, [ manualNavState,  appTopicsArr, contentTopics, setChangeContent, showGrid, showTeacherUrlModal, sizeState]);
  
   
}
  
export default useManualNavigation;
  